export default __webpack_public_path__ + "static/gilroy-semibold-2d5174094eb9f5837eaaa081e3a77c7b.woff";